export default __webpack_public_path__ + "static/media/randbfashion.8765dec7.png";